(() => {
  'use strict';
  function finishLabel(options, names, goldLabel, fallback, supplierRing = false, finishTemplate = '__FINISH__ finish') {
    let result = fallback || '';
    names.forEach((name, index) => {
      if (!/^(?:colou?r|finish|finish colou?r|metal)$/i.test(name.trim())) return;
      const value = String(options[index] || '');
      if (supplierRing) result = value ? finishTemplate.replace('__FINISH__', value) : '';
      else if (/rhodium/i.test(value)) result = /finish/i.test(value) ? value : `${value} finish`;
      else if (/white gold\s*\+\s*rose gold/i.test(value)) result = `${value} finish`;
      else if (/white gold/i.test(value)) result = 'White gold finish';
      else if (/\b(\d{1,2})\s*k(?:arat)?\b/i.test(value)) result = `${value.match(/\b(\d{1,2})\s*k(?:arat)?\b/i)[1]}K gold finish`;
      else if (/rose gold/i.test(value)) result = goldLabel.replace(/gold/i, 'rose gold');
      else if (/gold/i.test(value)) result = goldLabel;
      else if (/silver|platinum/i.test(value)) result = '';
    });
    return result;
  }
  function stoneLabel(options, names, fallback, supplierRing = false) {
    let result = fallback;
    const grade = fallback?.match(/^VVS(?:–VS)?/)?.[0] || 'VVS';
    names.forEach((name, index) => {
      const value = String(options[index] || '');
      if (/^stone$/i.test(name.trim())) result = /moissanite/i.test(value) ? value : '';
      else if (/^colou?r$/i.test(name.trim()) && /\+.*moissanite/i.test(value)) result = value.split(/\s*\+\s*/).slice(1).join(' + ');
    });
    if (!supplierRing && result && /moissanite/i.test(result) && !/vvs|\+/i.test(result)) result = `${grade} ${result}`;
    return result;
  }
  function initialize(root) {
    if (root.dataset.highlightsInitialized) return;
    root.dataset.highlightsInitialized = 'true';
    const product = root.closest('[data-jmo-product]');
    const track = root.querySelector('[data-jmo-highlights-track]');
    const list = root.querySelector('[data-jmo-highlights-list]');
    const supplierRing = root.dataset.highlightsMode === 'supplier-ring';
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    const cloneList = () => {
      track.querySelector('[aria-hidden="true"]')?.remove();
      const clone = list.cloneNode(true);
      clone.removeAttribute('data-jmo-highlights-list');
      clone.setAttribute('aria-hidden', 'true');
      track.append(clone);
    };
    const updateMotion = () => {
      const playing = !userPaused && !preference.matches;
      root.dataset.motion = playing ? 'playing' : 'paused';
      root.setAttribute('tabindex', preference.matches ? '-1' : '0');
      root.setAttribute('aria-description', preference.matches ? 'Product highlights' : `${playing ? 'Moving' : 'Paused'}. Tap or press Enter or Space to ${playing ? 'pause' : 'resume'} product highlights.`);
    };
    const updateFinish = () => {
      let data;
      try { data = JSON.parse(product.querySelector('[data-jmo-product-json]').textContent); } catch (_) { return; }
      const options = Array.from(product.querySelectorAll('[data-jmo-option]:checked')).map(input => input.value);
      const validSelection = Boolean(product.querySelector('[data-jmo-variant-select]')?.value);
      const finish = validSelection ? finishLabel(options, data.optionNames || [], root.dataset.goldLabel, root.dataset.defaultFinish, supplierRing, root.dataset.finishTemplate) : '';
      const item = list.querySelector('[data-jmo-highlight-finish]');
      item.textContent = finish;
      item.hidden = !finish;
      const stoneItem = list.querySelector('[data-jmo-highlight-stone]');
      const stone = validSelection ? stoneLabel(options, data.optionNames || [], stoneItem.dataset.defaultStone, supplierRing) : '';
      stoneItem.textContent = stone;
      stoneItem.hidden = !stone;
      const testerItem = list.querySelector('[data-jmo-highlight-tester]');
      if (testerItem) testerItem.hidden = supplierRing || !stone;
      cloneList();
    };
    const changedPreference = () => { updateMotion(); };
    const changedVisibility = () => { root.dataset.documentHidden = String(document.hidden); };
    const toggleMotion = () => { if (!preference.matches) { userPaused = !userPaused; updateMotion(); } };
    root.addEventListener('click', toggleMotion);
    root.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggleMotion();
    });
    product?.addEventListener('change', updateFinish);
    preference.addEventListener('change', changedPreference);
    document.addEventListener('visibilitychange', changedVisibility);
    (root.closest('.shopify-section') || root).addEventListener('shopify:section:unload', () => {
      preference.removeEventListener('change', changedPreference);
      document.removeEventListener('visibilitychange', changedVisibility);
      product?.removeEventListener('change', updateFinish);
    }, { once: true });
    cloneList();
    updateFinish();
    updateMotion();
    changedVisibility();
  }
  document.querySelectorAll('[data-jmo-highlights]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jmo-highlights]').forEach(initialize));
  if (typeof module !== 'undefined') module.exports = { finishLabel, stoneLabel, initialize };
})();
